module.exports = __webpack_public_path__ + "media/images/public-step2-6ac1ad37109537c2c6722aee2658cf0f.png";